// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error not typed

import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const CalleeSelectDropdownWrapper = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  maxBlockSize: "400px",
  overflow: "auto",
  flexDirection: "column",
  children: children
});
export const ThirdPartySettingsNumbersHelpDesk = props => {
  const {
    appIdentifier,
    calleesData,
    isKnownVisitor,
    visitorPhoneNumber,
    startOutboundCall
  } = props;
  return /*#__PURE__*/_jsx(CalleeSelectDropdownWrapper, {
    children: /*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData || null,
      onSelectToNumber: startOutboundCall,
      disabled: false,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: null,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber
    })
  });
};